import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import {  faLink } from '@fortawesome/free-solid-svg-icons';

function DataList({ data }) {
  return (
    <div className="data-list">
      {data.length > 0 ? (
        <div className="card-container">
          {data.map(item => (
            <div key={item.id} className="card">
              <div className="card-title">
                <h3>{item.name}</h3>
              </div>
              <div className="card-details">
              <p ><strong className="card-details-head">Autor Name - </strong> 
                {item.author}
                </p>
              </div>
              <div className="card-details">
                <p className="card-details-head"><strong>Category</strong> </p>

                  {item.category.map((category, index) => (
                    <li key={index}>{category}</li>
                  ))}
               
                {item.techniques && item.techniques.length > 0 && (
            <>
              <p className="card-details-head"><strong>Techniques</strong></p>
              <ul>
                {item.techniques.map((technique, index) => (
                  <li key={index}>- {technique}</li>
                ))}
              </ul>
            </>
          )}

          {item.tactics && item.tactics.length > 0 && (
            <>
              <p className="card-details-head"><strong>Tactics</strong></p>
              <ul>
                {item.tactic.map((tactic, index) => (
                  <li key={index}>- {tactic}</li>
                ))}
              </ul>
            </>
          )}

                
                
                <p className="card-details-head"><strong>Description</strong> </p>
                <p>{item.description}</p>
              </div>
              <div className="card-links">
                {item.github && <a href={item.github} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faGithub} /></a>}
                {item.url && <a href={item.url} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faLink} /></a>}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p>No data available for the selected filters.</p>
      )}
    </div>
  );
}

export default DataList;